import { Heading4, theme } from '@ovotech/element-v5';
import { Card as NebulaCard } from '@ovotech/nebula';
import styled from 'styled-components';

export const Card = styled(NebulaCard)`
  max-width: 810px;
  margin: 0 auto;
`;

export const Subheading = styled(Heading4)`
  color: ${theme.color.surface.onSurface};
  font-size: ${theme.font.size.lg.mediaQuery.lg};
`;
